import { Stack, Title, Divider, Loader, Card, Text } from "@mantine/core";
import { useGetAllRegistrationTicketTypeForEvent } from "../../api/registrationTicketTypes";
import TicketTypeCard from "./TicketTypeCard";

function TicketTypesList({ event }) {
  const { data, isLoading } = useGetAllRegistrationTicketTypeForEvent(event.id);

  if (isLoading) return <Loader />;

  const types = Array.isArray(data?.ticketTypes) ? data.ticketTypes : [];

  return (
    <Card shadow="sm" padding="lg" radius="md" mt="sm" withBorder>
      <Stack gap="lg">
        <Title order={4}>Ticket Types</Title>
        <Divider />

        {types.length === 0 ? (
          <Text c="dimmed">No ticket types</Text>
        ) : (
          <Stack gap="md">
            {types.map((t) => (
              <TicketTypeCard key={t.id} data={t} event={event} />
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
}

export default TicketTypesList;
